import { BaseUseCase } from "../../../useCases/UseCaseBase";
class MFSIPFrequencyUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getMfFrequency(req);
    }
}
export default MFSIPFrequencyUseCase;
